export const BRAND = {
    name: "RESET365",
    taglineFr: "Votre propriété, notre priorité.",
    taglineEn: "Your property, our priority.",
    phone: "438-923-0853",
    phoneHref: "tel:4389230853",
    email: "info@reset365.ca",
    emailHref: "mailto:info@reset365.ca",
    address: "#258, 365 Rue Sainte-Catherine Est, Montréal, QC H2X 3X2",
    serviceAreaFr: "Montréal et environs",
    serviceAreaEn: "Montreal and surrounding areas",
    logoUrl: "https://customer-assets-rejwkqb3.emergentagent.net/job_feca77be-7555-4bbb-9e92-543821f6131c/artifacts/0akwq9z1_1809942f-fa1d-46d9-a7d0-c62afc0e4a4d.jpeg",
};

export const IMAGES = {
    hero: "https://static.prod-images.emergentagent.com/jobs/feca77be-7555-4bbb-9e92-543821f6131c/images/cbbc79338dc854d269cfa10aab1a4d7acfb6418e180bfb1b6088be2d1444f460.jpeg",
    residential: "https://static.prod-images.emergentagent.com/jobs/feca77be-7555-4bbb-9e92-543821f6131c/images/435a2956ab731cb3a282f84983cb552d5db117ec93029d9eb040f77144a68900.jpeg",
    commercial: "https://static.prod-images.emergentagent.com/jobs/feca77be-7555-4bbb-9e92-543821f6131c/images/b435024dea0ec421424babf3e0e3777adb3f97218acb293f2738294c8d9e62d6.jpeg",
    detail: "https://static.prod-images.emergentagent.com/jobs/feca77be-7555-4bbb-9e92-543821f6131c/images/0708d47dfe883fbbfe28e6b70781bae1ff6571e40519958d2d34953088f83e4d.jpeg",
};

export const OFFER_IMAGES = {
    "01": { url: "https://images.unsplash.com/photo-1762810944373-d3cd437cbd1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxlbXB0eSUyMG1vZGVybiUyMGFwYXJ0bWVudHxlbnwwfHx8fDE3ODgyMjM4Mjh8MA&ixlib=rb-4.1.0&q=85", frAlt: "Appartement contemporain vide et nettoyé, prêt pour une remise des clés", enAlt: "Empty clean modern apartment ready for tenant turnover" },
    "02": { url: "https://images.unsplash.com/photo-1656646425148-9d0ebb0a778a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHw0fHxjb21tZXJjaWFsJTIwYnVpbGRpbmclMjBleHRlcmlvcnxlbnwwfHx8fDE3ODgyMjM4Mjh8MA&ixlib=rb-4.1.0&q=85", frAlt: "Immeuble commercial entretenu avec façade et entrée soignées", enAlt: "Professionally maintained commercial building exterior" },
    "03": { url: "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxyZW5vdmF0ZWQlMjBtb2Rlcm4lMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODgyMjM4Mjh8MA&ixlib=rb-4.1.0&q=85", frAlt: "Intérieur rénové propre et prêt pour la livraison", enAlt: "Clean renovated interior ready for handover" },
    propertyPassport: { url: "https://static.prod-images.emergentagent.com/jobs/feca77be-7555-4bbb-9e92-543821f6131c/images/350154d0226c082abdf38d281559cc10dc5cf2c338dac42a616e72eae0cbd9a9.jpeg", frAlt: "Maison entretenue et téléphone présentant un dossier numérique PropertyPassport", enAlt: "Maintained home and smartphone representing a PropertyPassport digital dossier" },
};

export const COPY = {
    fr: {
        languageLabel: "EN",
        languageAria: "Passer à la version anglaise",
        nav: [
            { label: "Accueil", href: "#accueil", id: "home" },
            { label: "Services", href: "#services", id: "services" },
            { label: "Résidentiel", href: "#residentiel", id: "residential" },
            { label: "Commercial", href: "#commercial", id: "commercial" },
            { label: "Comment ça fonctionne", href: "#processus", id: "process" },
            { label: "Contact", href: "#contact", id: "contact" },
        ],
        headerCta: "OBTENIR UNE SOUMISSION GRATUITE",
        headerCall: "APPELER",
        hero: {
            eyebrow: "ENTRETIEN IMMOBILIER · MONTRÉAL ET ENVIRONS",
            titleLines: ["L’entretien de votre", "propriété, toute", "l’année."],
            body: "Nettoyage extérieur et entretien immobilier professionnel pour résidences, commerces, immeubles et copropriétés à Montréal et environs.",
            primaryCta: "OBTENIR UNE SOUMISSION GRATUITE",
            secondaryCta: "APPELER RESET365",
            trust: "Soumission gratuite · Réponse rapide · Service professionnel",
            locationLabel: "SERVICE LOCAL",
            locationText: "Montréal et environs",
            imageAlt: "Maison contemporaine propre et entretenue après un lavage extérieur",
        },
        marquee: ["REMISE À 9", "EXTÉRIEUR 360", "RESET365 CHANTIER", "MONTRÉAL ET ENVIRONS"],
        services: {
            eyebrow: "01 / OFFRES",
            title: "Nos offres principales",
            subtitle: "Trois façons précises de remettre votre propriété au meilleur niveau, selon votre projet.",
            includedLabel: "SERVICES INCLUS",
            cards: [
                {
                    number: "01",
                    title: "REMISE À 9",
                    audience: "Pour agents immobiliers, propriétaires-bailleurs et gestionnaires",
                    text: "Remise en état complète d’un logement entre deux locataires ou avant vente/location.",
                    tagline: "Votre logement, prêt en un temps record.",
                    included: ["Nettoyage complet du logement", "Cuisines, salles de bain et planchers", "Dépoussiérage des surfaces et plinthes", "Vitres et revêtements accessibles", "Retouches mineures", "Préparation avant vente, location ou remise des clés"],
                    cta: "Obtenez votre soumission en quelques heures",
                },
                {
                    number: "02",
                    title: "EXTÉRIEUR 360",
                    audience: "Pour immeubles commerciaux et multi-résidentiels",
                    text: "Entretien de l’image extérieure d’un immeuble : façade, entrée, stationnement et aménagement.",
                    tagline: "La première impression de votre immeuble, toujours impeccable.",
                    included: ["Lavage à pression", "Lavage doux des surfaces délicates", "Façades et revêtements extérieurs", "Entrées, trottoirs, patios et stationnements", "Gouttières, vitrines et vitres extérieures", "Nettoyage des bacs et des chambres à déchets", "Entretien saisonnier et récurrent"],
                    cta: "Obtenez votre soumission en quelques heures",
                },
                {
                    number: "03",
                    title: "RESET365 CHANTIER",
                    audience: "Pour entrepreneurs, promoteurs et rénovateurs",
                    text: "Nettoyage final après construction ou rénovation pour livrer un espace prêt à occuper.",
                    tagline: "Du chantier à la livraison — prêt à occuper.",
                    included: ["Dépoussiérage fin après travaux", "Nettoyage des planchers, murs et surfaces", "Cuisines, salles de bain et détails de finition", "Vitres, cadrages et vitrines", "Retrait des résidus légers de chantier", "Préparation pour inspection, livraison ou remise des clés"],
                    cta: "Réservez avant la livraison",
                },
            ],
        },
        passport: {
            eyebrow: "PROPERTY PASSPORT™ / DOSSIER NUMÉRIQUE",
            title: "Chaque propriété mérite son propre historique.",
            body: "Un lien simple pour retrouver les photos avant/après, les interventions, les documents et la prochaine recommandation d’entretien — sans application à télécharger.",
            items: ["Photos avant / après", "Historique des services", "Factures et garanties", "Rappels d’entretien"],
            cta: "DÉCOUVRIR PROPERTY PASSPORT™",
            imageAlt: "Maison entretenue et téléphone présentant un dossier numérique PropertyPassport",
            modal: {
                title: "Votre propriété. Son historique. Au même endroit.",
                body: "PropertyPassport™ est un dossier numérique privé qui donne à votre client une vue claire de ce qui a été fait et de ce qui vient ensuite.",
                items: ["Photos avant et après les interventions", "Historique des services et des notes", "Factures et garanties accessibles", "Rappels d’entretien selon le besoin"],
                note: "Aucune application à télécharger, aucun compte client à créer : un lien unique suffit.",
                cta: "OBTENIR UNE SOUMISSION GRATUITE",
                close: "FERMER",
            },
        },
        priority: {
            eyebrow: "02 / NOTRE APPROCHE",
            title: "Une propriété. Une priorité.",
            body: "Chez RESET365, nous simplifions l’entretien extérieur de votre propriété grâce à des services professionnels adaptés à vos besoins.",
            benefits: [
                { title: "SOUMISSION GRATUITE", text: "Simple et sans engagement." },
                { title: "SERVICE PROFESSIONNEL", text: "Une approche structurée et orientée vers la qualité." },
                { title: "SOLUTIONS ADAPTÉES", text: "Chaque propriété a des besoins différents." },
                { title: "MONTRÉAL ET ENVIRONS", text: "Service local pour les propriétés de la région." },
            ],
        },
        process: {
            eyebrow: "03 / COMMENT ÇA FONCTIONNE",
            title: "Simple. Rapide. Sans complication.",
            steps: [
                { number: "01", title: "Demandez votre soumission", text: "Remplissez notre formulaire en quelques minutes." },
                { number: "02", title: "Recevez votre estimation", text: "Nous évaluons votre projet et déterminons la solution adaptée." },
                { number: "03", title: "RESET365 s’occupe du reste", text: "Une fois le service confirmé, nous réalisons le travail selon les conditions convenues." },
            ],
            cta: "OBTENIR MA SOUMISSION GRATUITE",
        },
        residential: {
            eyebrow: "04 / RÉSIDENTIEL",
            title: "Pour votre propriété",
            body: "Une apparence soignée commence par un entretien extérieur régulier, pensé pour votre maison et votre quotidien.",
            list: ["Maisons", "Condos", "Entrées", "Terrasses", "Gouttières", "Vitres extérieures", "Revêtements extérieurs", "Entretien saisonnier"],
            cta: "OBTENIR UNE SOUMISSION",
            imageAlt: "Entrée résidentielle propre avec pavé, végétation et façade contemporaine",
            imageLabel: "RÉSIDENTIEL",
        },
        commercial: {
            eyebrow: "05 / COMMERCIAL",
            title: "Pour votre entreprise ou votre immeuble",
            body: "Présentez une propriété accueillante et entretenue avec des solutions adaptées aux commerces, bureaux, immeubles et copropriétés.",
            list: ["Commerces", "Vitrines", "Bureaux", "Immeubles à logements", "Copropriétés", "Entrées", "Trottoirs", "Façades", "Entretien récurrent"],
            cta: "PARLER À RESET365",
            imageAlt: "Façade commerciale moderne avec vitrines et entrée propre",
            imageLabel: "COMMERCIAL",
        },
        local: {
            eyebrow: "06 / LOCAL",
            title: "Montréal et environs",
            body: "RESET365 dessert les propriétés résidentielles et commerciales à Montréal et dans les secteurs environnants.",
            cta: "VÉRIFIER LA DISPONIBILITÉ",
            note: "Nous vous confirmerons la disponibilité pour votre adresse.",
        },
        quote: {
            eyebrow: "07 / SOUMISSION",
            title: "Obtenez votre soumission gratuite",
            subtitle: "Parlez-nous de votre projet et nous communiquerons avec vous rapidement.",
            labels: { name: "Nom", phone: "Téléphone", email: "Courriel", address: "Adresse de la propriété", property: "Type de propriété", service: "Service recherché", description: "Décrivez votre projet", photos: "Téléverser des photos" },
            placeholders: { name: "Votre nom", phone: "438-923-0853", email: "vous@exemple.ca", address: "Adresse de la propriété", description: "Parlez-nous de la surface, du bâtiment ou de la fréquence souhaitée..." },
            propertyOptions: ["Maison", "Condo", "Immeuble", "Commerce", "Autre"],
            serviceOptions: ["Remise à 9", "Extérieur 360", "RESET365 Chantier", "Autre"],
            selectPlaceholder: "Sélectionner",
            photosHint: "JPG, PNG ou HEIC · 5 fichiers maximum",
            submit: "ENVOYER MA DEMANDE",
            submitting: "ENVOI EN COURS…",
            fileNone: "Aucune photo sélectionnée",
            privacy: "Vos informations servent à traiter votre demande et à vous contacter au sujet de votre projet.",
            success: "Merci! Votre demande a bien été reçue. L’équipe RESET365 communiquera avec vous rapidement.",
            error: "Une erreur est survenue. Appelez-nous au 438-923-0853 ou réessayez dans un instant.",
            asideTitle: "Chaque projet commence par une conversation.",
            asideBody: "Décrivez-nous votre propriété. Nous vous aiderons à identifier la bonne solution, sans engagement.",
        },
        contact: {
            eyebrow: "08 / CONTACT",
            title: "Parlons de votre propriété",
            tagline: "Votre propriété, notre priorité.",
            phoneLabel: "Téléphone",
            emailLabel: "Courriel",
            areaLabel: "Zone desservie",
            addressLabel: "Adresse",
            call: "APPELER RESET365",
            email: "ENVOYER UN COURRIEL",
        },
        final: {
            eyebrow: "RESET365",
            title: "Votre propriété mérite un RESET.",
            body: "Besoin d’un nettoyage extérieur ou d’un entretien régulier? Demandez votre soumission gratuite dès aujourd’hui.",
            primary: "OBTENIR MA SOUMISSION GRATUITE",
            secondary: "438-923-0853",
        },
        footer: {
            descriptor: "Votre propriété, notre priorité.",
            linksTitle: "Navigation",
            contactTitle: "Parlons-en",
            privacy: "Politique de confidentialité",
            terms: "Conditions d’utilisation",
            legalNote: "Les informations légales détaillées seront publiées avant la mise en ligne. Pour toute question, contactez-nous directement.",
            copyright: "© 2026 RESET365. Tous droits réservés.",
        },
    },
    en: {
        languageLabel: "FR",
        languageAria: "Switch to the French version",
        nav: [
            { label: "Home", href: "#accueil", id: "home" },
            { label: "Services", href: "#services", id: "services" },
            { label: "Residential", href: "#residentiel", id: "residential" },
            { label: "Commercial", href: "#commercial", id: "commercial" },
            { label: "How it works", href: "#processus", id: "process" },
            { label: "Contact", href: "#contact", id: "contact" },
        ],
        headerCta: "GET A FREE QUOTE",
        headerCall: "CALL",
        hero: {
            eyebrow: "PROPERTY MAINTENANCE · MONTREAL AND SURROUNDING AREAS",
            titleLines: ["Property maintenance,", "all year", "round."],
            body: "Professional exterior cleaning and property maintenance for homes, businesses, buildings and condominiums in Montreal and surrounding areas.",
            primaryCta: "GET A FREE QUOTE",
            secondaryCta: "CALL RESET365",
            trust: "Free quote · Fast response · Professional service",
            locationLabel: "LOCAL SERVICE",
            locationText: "Montreal and surrounding areas",
            imageAlt: "Clean contemporary home maintained after professional exterior cleaning",
        },
        marquee: ["RESET 9", "EXTERIOR 360", "RESET365 CONSTRUCTION CLEANUP", "MONTREAL AND SURROUNDING AREAS"],
        services: {
            eyebrow: "01 / OFFERS",
            title: "Our core offers",
            subtitle: "Three focused ways to bring a property back to its best, depending on the project.",
            includedLabel: "WHAT’S INCLUDED",
            cards: [
                {
                    number: "01",
                    title: "RESET 9",
                    audience: "For real estate agents, landlords and property managers",
                    text: "A complete turnover reset between tenants or before a sale or rental listing.",
                    tagline: "Your space, ready in record time.",
                    included: ["Complete home or unit cleaning", "Kitchens, bathrooms and floors", "Dusting surfaces and baseboards", "Accessible windows and finishes", "Minor touch-ups", "Preparation before sale, rental or handover"],
                    cta: "Get your quote within hours",
                },
                {
                    number: "02",
                    title: "EXTERIOR 360",
                    audience: "For commercial and multi-residential properties",
                    text: "A complete exterior image-maintenance service: facade, entrance, parking and landscaping.",
                    tagline: "Your building’s first impression, always impeccable.",
                    included: ["Pressure washing", "Soft washing for delicate surfaces", "Facades and exterior siding", "Entrances, sidewalks, patios and parking areas", "Gutters, storefronts and exterior windows", "Waste bin and waste-room cleaning", "Seasonal and recurring maintenance"],
                    cta: "Get your quote within hours",
                },
                {
                    number: "03",
                    title: "RESET365 CONSTRUCTION CLEANUP",
                    audience: "For contractors, developers and renovators",
                    text: "Final cleaning after construction or renovation, so the space is ready to occupy.",
                    tagline: "From jobsite to handover — ready to occupy.",
                    included: ["Fine post-construction dust removal", "Floors, walls and surface cleaning", "Kitchens, bathrooms and finishing details", "Windows, frames and storefronts", "Removal of light construction residue", "Preparation for inspection, handover or move-in"],
                    cta: "Book before handover",
                },
            ],
        },
        passport: {
            eyebrow: "PROPERTY PASSPORT™ / DIGITAL PROPERTY FILE",
            title: "Every property deserves its own history.",
            body: "One simple link for before-and-after photos, completed services, documents and the next maintenance recommendation — no app download required.",
            items: ["Before / after photos", "Service history", "Invoices and warranties", "Maintenance reminders"],
            cta: "DISCOVER PROPERTY PASSPORT™",
            imageAlt: "Clean interior presented in a PropertyPassport digital property file",
            modal: {
                title: "Your property. Its history. In one place.",
                body: "PropertyPassport™ is a private digital property file that gives your client a clear view of what was done and what comes next.",
                items: ["Before-and-after service photos", "Service history and notes", "Invoices and warranties in one place", "Maintenance reminders when needed"],
                note: "No app to download and no client account to create: one simple link is enough.",
                cta: "GET A FREE QUOTE",
                close: "CLOSE",
            },
        },
        priority: {
            eyebrow: "02 / OUR APPROACH",
            title: "One property. One priority.",
            body: "At RESET365, we make exterior property maintenance simpler with professional services adapted to your needs.",
            benefits: [
                { title: "FREE QUOTE", text: "Simple and no obligation." },
                { title: "PROFESSIONAL SERVICE", text: "A structured approach focused on quality." },
                { title: "ADAPTED SOLUTIONS", text: "Every property has different needs." },
                { title: "MONTREAL AND SURROUNDING AREAS", text: "Local service for properties in the region." },
            ],
        },
        process: {
            eyebrow: "03 / HOW IT WORKS",
            title: "Simple. Fast. No complications.",
            steps: [
                { number: "01", title: "Request your quote", text: "Fill out our form in just a few minutes." },
                { number: "02", title: "Receive your estimate", text: "We review your project and determine the right solution." },
                { number: "03", title: "RESET365 handles the rest", text: "Once the service is confirmed, we complete the work under the agreed conditions." },
            ],
            cta: "GET MY FREE QUOTE",
        },
        residential: {
            eyebrow: "04 / RESIDENTIAL",
            title: "For your property",
            body: "A well-kept exterior starts with regular maintenance designed around your home and your day-to-day life.",
            list: ["Homes", "Condos", "Driveways", "Decks and patios", "Gutters", "Exterior windows", "Exterior siding", "Seasonal maintenance"],
            cta: "GET A QUOTE",
            imageAlt: "Clean residential entry with paving, landscaping and contemporary facade",
            imageLabel: "RESIDENTIAL",
        },
        commercial: {
            eyebrow: "05 / COMMERCIAL",
            title: "For your business or building",
            body: "Present a welcoming, maintained property with solutions suited to businesses, offices, buildings and condominiums.",
            list: ["Businesses", "Storefronts", "Offices", "Rental buildings", "Condominiums", "Entrances", "Sidewalks", "Facades", "Recurring maintenance"],
            cta: "TALK TO RESET365",
            imageAlt: "Modern commercial facade with clean windows and entrance",
            imageLabel: "COMMERCIAL",
        },
        local: {
            eyebrow: "06 / LOCAL",
            title: "Montreal and surrounding areas",
            body: "RESET365 serves residential and commercial properties in Montreal and surrounding areas.",
            cta: "CHECK AVAILABILITY",
            note: "We will confirm availability for your address.",
        },
        quote: {
            eyebrow: "07 / QUOTE",
            title: "Get your free quote",
            subtitle: "Tell us about your project and we will get back to you quickly.",
            labels: { name: "Name", phone: "Phone", email: "Email", address: "Property address", property: "Property type", service: "Service needed", description: "Tell us about your project", photos: "Upload photos" },
            placeholders: { name: "Your name", phone: "438-923-0853", email: "you@example.ca", address: "Property address", description: "Tell us about the surface, building or preferred frequency..." },
            propertyOptions: ["House", "Condo", "Building", "Business", "Other"],
            serviceOptions: ["Reset 9", "Exterior 360", "RESET365 Construction Cleanup", "Other"],
            selectPlaceholder: "Select one",
            photosHint: "JPG, PNG or HEIC · 5 files maximum",
            submit: "SEND MY REQUEST",
            submitting: "SENDING…",
            fileNone: "No photo selected",
            privacy: "Your information is used to process your request and contact you about your project.",
            success: "Thank you! Your request has been received. The RESET365 team will contact you shortly.",
            error: "Something went wrong. Call us at 438-923-0853 or try again in a moment.",
            asideTitle: "Every project starts with a conversation.",
            asideBody: "Tell us about your property. We will help identify the right solution, with no obligation.",
        },
        contact: {
            eyebrow: "08 / CONTACT",
            title: "Let’s talk about your property",
            tagline: "Your property, our priority.",
            phoneLabel: "Phone",
            emailLabel: "Email",
            areaLabel: "Service area",
            addressLabel: "Address",
            call: "CALL RESET365",
            email: "SEND AN EMAIL",
        },
        final: {
            eyebrow: "RESET365",
            title: "Your property deserves a RESET.",
            body: "Need exterior cleaning or recurring maintenance? Request your free quote today.",
            primary: "GET MY FREE QUOTE",
            secondary: "438-923-0853",
        },
        footer: {
            descriptor: "Your property, our priority.",
            linksTitle: "Navigation",
            contactTitle: "Let’s talk",
            privacy: "Privacy policy",
            terms: "Terms of use",
            legalNote: "Detailed legal information will be published before launch. For any questions, contact us directly.",
            copyright: "© 2026 RESET365. All rights reserved.",
        },
    },
};
